const caviSlider = [
    {id: 1,slImage: 'assets/images/cav1.jpeg'},
    {id: 2,slImage: 'assets/images/cav2.jpeg'},
    {id: 3,slImage: 'assets/images/cav3.jpeg'},
    {id: 4,slImage: 'assets/images/cav4.jpeg'},
    {id: 5,slImage: 'assets/images/cav5.jpeg'}
  ];
  
export default caviSlider;